import { makeStyles, tokens } from "@fluentui/react-components";

export const useAppTabBarStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    columnGap: "0",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    backgroundColor: tokens.colorBrandBackground2,
  },
  overflowContainer: {
    backgroundColor: tokens.colorBrandBackground2,
    overflow: "hidden",
    padding: "0 0 0 5px",
    zIndex: 0,
    alignSelf: "flex-end",
    alignItems: "flex-end",
    minWidth: "150px",
    width: "100%",
  },
});
